const DB_NAME = 'es-shop-cart'
const STORE = 'esLocalStore'
const BASE_KEY = 'ES_SHOP_CART'

const cartKey = () => {
  try {
    const saved = JSON.parse(localStorage.getItem('vuex') || '{}')
    const usercode = saved.userInfo && saved.userInfo.usercode
    if (usercode) return `${BASE_KEY}_${usercode}`
  } catch (_) {}
  return BASE_KEY
}

const openDb = (version) => new Promise((resolve, reject) => {
  const request = version ? indexedDB.open(DB_NAME, version) : indexedDB.open(DB_NAME)
  request.onupgradeneeded = () => {
    const db = request.result
    const store = db.objectStoreNames.contains(STORE)
      ? request.transaction.objectStore(STORE)
      : db.createObjectStore(STORE, { keyPath: 'id', autoIncrement: true })
    if (!store.indexNames.contains('key')) store.createIndex('key', 'key', { unique: false })
    if (!store.indexNames.contains('value')) store.createIndex('value', 'value', { unique: false })
  }
  request.onsuccess = () => {
    const db = request.result
    db.onversionchange = () => db.close()
    if (!db.objectStoreNames.contains(STORE)) {
      const next = db.version + 1
      db.close()
      openDb(next).then(resolve, reject)
    } else resolve(db)
  }
  request.onerror = () => reject(request.error)
  request.onblocked = () => reject(new Error('Please close other shop tabs and retry.'))
})

const withStore = async (mode, run) => {
  const db = await openDb()
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE, mode)
    const request = run(transaction.objectStore(STORE))
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
    transaction.oncomplete = () => db.close()
  })
}

export const readCart = async () => {
  const record = await withStore('readonly', store => store.index('key').get(cartKey()))
  if (!record) return []
  try { return JSON.parse(record.value) || [] } catch (_) { return [] }
}

export const writeCart = async items => {
  const key = cartKey()
  const current = await withStore('readonly', store => store.index('key').get(key))
  return withStore('readwrite', store => store.put({ ...(current || {}), key, value: JSON.stringify(items) }))
}
